"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeConfig = exports.ThemeConfig = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ThemeContext = /*#__PURE__*/_react.default.createContext({});

/**
 * The custom hook to access the theming configuration.
 * @returns
 */
const useThemeConfig = () => _react.default.useContext(ThemeContext);

/**
 * The helper component to pass theming configurations to the underlying components.
 * @param props
 * @returns
 */
exports.useThemeConfig = useThemeConfig;
const ThemeConfig = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(ThemeContext.Provider, {
    value: props
  }, children);
};
exports.ThemeConfig = ThemeConfig;